import axios from 'axios';

// Currently, only the compareApiHelper() function of SizingToolService uses axios directly
export const setAxiosConfig = () => {
  axios.defaults.headers.common['Content-Type'] = 'application/json';
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      console.log(error);
      return Promise.reject(error);
    },
  );
};
